import { chatStore } from '../../modules/shared/stores/chatStore';
import { getCustomerAvailableModules } from '../../modules/shared/utils/paidModulesUtils';
import { CUSTOMER_PROFILE_TAB_NAMES } from '../../modules/shared/constants/tabNames/CUSTOMER_PROFILE_TAB_NAMES';
import { pathQueryParams } from '../../modules/shared/constants/pathQueryParams';
import { inbodyIndicatorsStore } from '../../modules/inbody';
import { communicationModalStore } from '../../modules/chat/stores/communicationModalStore';
import { unreadScansCountStore } from '../../modules/shared/stores/unreadScansCountStore';

(function () {
    'use strict';

    angular.module('app.customerProfile')
        .controller('CustomerProfileController', CustomerProfileController);

    CustomerProfileController.$inject = [
        '$scope',
        '$rootScope',
        '$routeParams',
        '$mdDialog',
        'utilService',
        'ModalService',
        'CustomerService',
        'CoachService',
        'EntityService',
        'MealPlanService',
        'constants',
        'AnalyticService',
        'PaymentService'
    ];

    function CustomerProfileController($scope, $rootScope, $routeParams, $mdDialog, utilService,
                                       ModalService, CustomerService, CoachService, EntityService,
                                       MealPlanService, constants, AnalyticService, PaymentService) {
        var vm = this;
        vm.tabNames = CUSTOMER_PROFILE_TAB_NAMES;
        vm.loggedInUser = utilService.getLoggedInUserData();
        vm.mainTabName = null;
        vm.searchButtonText = '+ Add new scan';
        vm.suggestionType = constants.suggestionType;
        vm.mainProfileSpinner = { active: false };
        vm.inbodyTypes = constants.inbodyTypes;
        vm.scanDates = [];
        vm.canSeeCompliance = canSeeCompliance(vm.loggedInUser.role);
        vm.isChildEntity = utilService.getIsChildEntity();
        vm.customerAvailableModules = {};
        vm.paymentFlowType = {};
        vm.isCoach = utilService.getIsCoachRole();
        vm.customerId = $routeParams.id;
        vm.firstScan = '';
        vm.entryFields = {};
        vm.complianceCoach = utilService.getComplianceCoachIndicator();

        vm.getUserInfoById = getUserInfoById;
        vm.popop = popop;
        vm.showEditPlanDialog = showEditPlanDialog;
        vm.showMessageDialog = showMessageDialog;
        vm.getScanDates = getScanDates;
        vm.goTo = goTo;
        vm.getCurrentEntity = getCurrentEntity;
        vm.setEntityInfo = setEntityInfo;
        vm.getEntityInfoBySuperuser = getEntityInfoBySuperuser;
        vm.getEntityInfoByAdmin = getEntityInfoByAdmin;
        vm.getEntityInfoByAgent = getEntityInfoByAgent;
        vm.getNewInbodyScans = getNewInbodyScans;
        vm.markUserAsSeen = markUserAsSeen;
        vm.addScanManually = addScanManually;
        vm.openChatWithCurrentCustomer = openChatWithCurrentCustomer;
        vm.setCustomerAvailableModules = setCustomerAvailableModules;
        vm.setInitialTab = setInitialTab;
        vm.getDefaultTab = getDefaultTab;
        vm.setPaymentFlowType = setPaymentFlowType;
        vm.refreshInBodyScans = refreshInBodyScans;

        // run on changeMealPlanDialog in modal service (mainTabName: constants.tabNames (some of tab), tabName: editPage (EDIT_MACRO_PLAN or SUGGESTED_MEAL_PLAN))
        $scope.$on('changeTab', function (event, opt) {
            vm.goTo(opt.mainTabName, opt.tabName);
        });

        vm.$onInit = async () => {
            await Promise.all([
              vm.setCustomerAvailableModules(),
              vm.getUserInfoById(),
              vm.getScanDates(),
            ]);

            // dependent on currentCustomerDetails
            await Promise.all([
                vm.getCurrentEntity(),
                vm.setPaymentFlowType()
            ]);

            vm.setInitialTab();

            utilService.applyAsyncFunc($scope);
        };

        $scope.$on('$destroy', () => {
            inbodyIndicatorsStore.setDefaultValues();
        });

        function setInitialTab() {
            const {initialTabName} = pathQueryParams;
            const initialTab = $routeParams[initialTabName];

            if (CUSTOMER_PROFILE_TAB_NAMES[initialTab]) {
                vm.mainTabName = initialTab;
            } else {
                vm.mainTabName = vm.getDefaultTab();
            }
        }

        function getDefaultTab() {
            if (vm.customerAvailableModules.NUTRITION || vm.customerAvailableModules.SCHOLASTIC) {
                return vm.tabNames.PERFORMANCE_METRICS;
            } else if (vm.customerAvailableModules.ACTIVE_CALENDAR) {
                return vm.tabNames.ACTIVE_CALENDAR_CUSTOMER_OVERVIEW;
            } else {
                return vm.tabNames.CUSTOMER_PROFILE;
            }
        }

        function getUserInfoById() {
            vm.mainProfileSpinner.active = true;
            return CustomerService.getCustomerDetails(vm.loggedInUser.id, $routeParams.id).then(function (res) {
                vm.mainProfileSpinner.active = false;
                if (res.status === 200) {
                    localStorage.setItem('complianceCoachForCustomer',
                        JSON.stringify(vm.loggedInUser.id !== res.data.coach.id && vm.loggedInUser.role === 'AGENT'));
                    vm.currentCustomerDetails = res.data;
                    if (res.data.newScansAvailable === true) {
                        vm.getNewInbodyScans();
                    }
                }
            });
        }

        function markUserAsSeen() {
            unreadScansCountStore.markNutritionCustomerScanSeen($routeParams.id);
        }

        function canSeeCompliance(role) {
            return ['ADMIN','SUPERUSER','AGENT'].indexOf(role) >=0;
        }

        async function getCurrentEntity() {
            switch (vm.loggedInUser.role) {
                case 'SUPERUSER':
                    await vm.getEntityInfoBySuperuser();
                    break;
                case 'ADMIN':
                    await vm.getEntityInfoByAdmin();
                    break;
                case 'AGENT':
                    await vm.getEntityInfoByAgent();
                    break;
            }

            utilService.applyAsyncFunc($scope);
        }

        function getEntityInfoBySuperuser() {
           return EntityService.getEntityById(vm.currentCustomerDetails.gymId).then(function (result) {
                if (result.status === 200) {
                    vm.setEntityInfo(result.data);
                }
            })
        }

        function getEntityInfoByAdmin() {
            return EntityService.getEntitiesOfAdmin().then(function (result) {
                if (result.status === 200) {
                    vm.setEntityInfo(result.data.entities[0]);
                }
            });
        }

        function getEntityInfoByAgent() {
            return CoachService.getCurrentEntityInfo().then(function (result) {
                if (result.status === 200) {
                    vm.setEntityInfo(result.data);
                }
            })
        }

        function setEntityInfo(entity) {
            localStorage.setItem('supportedInbodyTypes', JSON.stringify(entity.supportedInbodyTypes));
            // TODO delete set entryFields to localStorage after update set scan manually
            localStorage.setItem('entryFields', JSON.stringify(entity.entryFields));
            vm.entryFields = entity.entryFields;
            localStorage.setItem('allowNonInbodyUsers', JSON.stringify(entity.allowNonInbodyUsers));
        }

        function popop(data) {
            if (data?.status === 'Success') {
                AnalyticService.pushEvent('addEvents_makeConversions', 'd-v1-e3', 'scan', 'add',
                    {'customer_id': $routeParams.id});
            }
            vm.getScanDates().then(function () {
                // should check because getMealAdjustments return error when less than 2 scans
                if (vm.scanDates.length >= 2) {
                    MealPlanService.getMealAdjustments($routeParams.id).then(function (result) {
                        if (result.status === 200) {
                            ModalService.changeMealPlanDialog(
                                vm.currentCustomerDetails,
                                data.status,
                                vm.mainTabName,
                                result.data.type === vm.suggestionType.SCENARIO,
                                vm.scanDates
                            );
                        } else if (result.status === 404) {
                            ModalService.changeMealPlanDialog(vm.currentCustomerDetails, data.status, vm.mainTabName, false, vm.scanDates)
                        }
                    })
                } else {
                    ModalService.changeMealPlanDialog(vm.currentCustomerDetails, 'Success', vm.mainTabName, false, vm.scanDates)
                }
            });
        }

        function getNewInbodyScans() {
            vm.popop({status: 'Success'});
            vm.markUserAsSeen();
            AnalyticService.pushEvent('addEvents_makeConversions', 'd-v1-e5', 'scan', 'open_user_with_scan_from_webhook',
                {'customer_id': $routeParams.id});
        }

        function showEditPlanDialog() {
            vm.searchButtonText = 'Adding...';
            CustomerService.getInbodyDataForUser($routeParams.id).then(function (res) {
                vm.searchButtonText = '+ Add new scan';
                vm.refreshInBodyScans();
                switch (res.status) {
                    case 200:
                        vm.popop(res.data);
                        break;
                    default:
                        vm.addScanManually(true)
                        break;
                }
            });
            AnalyticService.pushEvent('addEvents_makeConversions', 'd-v1-e2', 'scan', 'click_btn_add_new_scan',
                {'customer_id': $routeParams.id});
        }

        function showMessageDialog() {
            const generalConfig = {
                via: 'EMAIL',
                customerIds: [vm.currentCustomerDetails.id],
                customersCount: 1,
            };

            if (vm.customerAvailableModules.SCHOLASTIC) {
                communicationModalStore.openCommunicationModal({
                    ...generalConfig,
                    resourceType: 'scholastic',
                });
            } else if (vm.customerAvailableModules.ACTIVE_CALENDAR) {
                communicationModalStore.openCommunicationModal({
                    ...generalConfig,
                    resourceType: 'customers',
                    useLegacyApi: true,
                });
            } else {
                // general nutrition customers
                communicationModalStore.openCommunicationModal({
                    ...generalConfig,
                    resourceType: 'customers',
                });
            }
        }

        function getScanDates() {
            return CustomerService.getUserScanDates($routeParams.id).then(function (res) {
                if (res.status === 200) {
                    vm.scanDates = res.data.scanDates;
                    vm.lastScan = res.data.scanDates.length > 0 ? res.data.scanDates[0] : null;
                    vm.firstScan = vm.scanDates.at(-1);
                }
            });
        }

        function addScanManually(isAutomaticScanFallback = false) {
          ModalService.addScanManually({
              inBodyType: vm.currentCustomerDetails.customer.inbodyType,
              entityId: vm.currentCustomerDetails.gymId,
              customerId: vm.customerId,
              onComplete: vm.refreshInBodyScans,
              popup: vm.popop,
              isAutomaticScanFallback,
            }
          )
        }

        function goTo(mainTabName, tabName) {
            vm.mainTabName = mainTabName;

            if (vm.mainTabName === vm.tabNames.MEAL_PLAN) {
                localStorage.setItem(tabName, JSON.stringify(true));
            }
        }

        function refreshInBodyScans() {
            inbodyIndicatorsStore.reInitData();
        }

        async function openChatWithCurrentCustomer() {
            await chatStore.openChatWithCustomer(vm.currentCustomerDetails.id);
        }

        async function setCustomerAvailableModules() {
            const customerAvailableModules = await getCustomerAvailableModules($routeParams.id);
            vm.customerAvailableModules = customerAvailableModules;
        }

        // TODO no spinner, current one will be closed after 1st request on init
        async function setPaymentFlowType() {
            const { paymentFlowTypeFlags } = await PaymentService.getSystemPaymentInfo(
                vm.currentCustomerDetails.gymId
            );

            vm.paymentFlowType = paymentFlowTypeFlags;

            utilService.applyAsyncFunc($scope);
        }
    }
})();
